export default __webpack_public_path__ + "static/media/OCGO-main.c0160555.jpg";